import type { ActivityKind } from '@/pages/ats-job-creation/tabs/interview-plan/stage/automation/types';

// Default delay between move-commit and `/workflow_executions/.../
// trigger`. Window during which the user can hover-to-pause and Stop.
export const UNDERWAY_DELAY_MS = 15_000;

export type UnderwayCandidate = {
  id: string;
  name: string;
  avatarUrl?: string;
  profileUrl?: string;
};

export type UnderwayStatus =
  | 'pending'
  | 'paused'
  | 'running'
  | 'completed'
  | 'failed'
  | 'cancelled';

export type UnderwayActivity = {
  id: string;
  activityKind: ActivityKind | string;
  activityLabel: string;
  stageId: string;
  stageName: string;
  jobId: string;
  jobName: string;
  candidates: UnderwayCandidate[];
  isBulk: boolean;
  executionIds: number[];
  createdAt: number;
  delayMs: number;
  remainingMs: number;
  pausedAt: number | null;
  status: UnderwayStatus;
  errorMessage?: string;
};

export type UnderwayViewMode = 'expanded' | 'minimized' | 'hidden';
